import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { MapProvider } from "./store/MapContext";
import { NavigationProvider } from "./store/NavigationContext";
import Map from "components/Map/Map";
import ErrorBoundary from "./components/ErrorBoundary";
import "./App.css";
import ThemeLoader from "./theme/ThemeLoader";

const App = () => {
	return (
		<ThemeLoader>
			<ErrorBoundary>
				<Router>
					<MapProvider>
						<NavigationProvider>
							<Routes>
								<Route
									path='/'
									element={<Map initialCenter={[-74.5, 40]} initialZoom={9} />}
								/>
							</Routes>
						</NavigationProvider>
					</MapProvider>
				</Router>
			</ErrorBoundary>
		</ThemeLoader>
	);
};

export default App;
